export enum EDegradationLevel {
    GoodState = 1,
    BadState = 2,
    LocalDegradation = 3,
    NotAccessible = 4,
    Disbonding = 5,
    PartialDegradation = 6,
    Degraded = 7,
    NotDegraded = 8,
    NotCommunicated = 9,
    GeneralDegradation
}